module.exports = __webpack_public_path__ + "img/transport_pic04.d22c4ee8.jpg";